import { UpdateTeethStateReq_ToothUpdate } from '@/shared/api/protocol-ts/api/core/svc_report_pb';
import { ToothNumeration } from '@/shared/api/protocol-ts/model/dto_report_common_pb';
import { ReportType } from '@/shared/api/protocol-ts/model/dto_report_pb';
import { PendingChange } from '@/shared/config';

import { getTargetByReportType } from './getTargetByReportType';

export const createUpdateRequests = (
  removes: PendingChange[],
  changes: PendingChange[],
  reportType?: ReportType,
): UpdateTeethStateReq_ToothUpdate[] => {
  const removeUpdates = removes.map(
    (remove) =>
      new UpdateTeethStateReq_ToothUpdate({
        Target: getTargetByReportType(remove, reportType),
        Action: {
          case: 'MarkDeleted',
          value: {},
        },
      }),
  );

  const changeUpdates = changes.map(
    (change) =>
      new UpdateTeethStateReq_ToothUpdate({
        Target: getTargetByReportType(change, reportType),
        Action: {
          case: 'SetNumeration',
          value: new ToothNumeration({
            ISO: change.newNumber,
            SupernumeraryIndex: change.SupernumeraryIndex,
          }),
        },
      }),
  );

  return [...removeUpdates, ...changeUpdates];
};
